<template>
  <div class="voz-guideline-striking-content" id="identidade-verbal-voz-marcante-e-inconfundivel" data-search-anchor>
    <h1 class="voz-guideline-striking-title">{{ vozGuidelineStrikingTitle }}</h1>
    <p class="voz-guideline-striking-paragraph">{{ vozGuidelineStrikingParagraph }}</p>

    <div class="voz-guideline-striking-wrapper">
      <div class="voz-guideline-striking-card" :style="{ backgroundImage: `url(${vozGuidelineStrikingImageSrc})` }">
        <div class="voz-guideline-striking-overlay">

          <h1 class="voz-guideline-striking-number">2</h1>

          <div class="voz-guideline-striking-content-text">
            <h3 class="voz-guideline-striking-card-title">
              {{ vozGuidelineStrikingCardTitle }}
            </h3>

            <p class="voz-guideline-striking-text">
              {{ vozGuidelineStrikingText }}
            </p>
          </div>

        </div>
      </div>

      <div class="voz-guideline-striking-column">
        <div class="voz-striking-icon-paragraph-title">
          <IconCheck />
          <h1 class="voz-guideline-striking-prefer-paragraph-title">
            {{ vozGuidelinestrikingParagraphPref }}
          </h1>
        </div>
        <p class="voz-guideline-striking-prefer-paragraph">{{ vozGuidelinePreferParagraph1 }}</p>
        <p class="voz-guideline-striking-prefer-paragraph">{{ vozGuidelinePreferParagraph2 }}</p>
        <p class="voz-guideline-striking-prefer-paragraph">{{ vozGuidelinePreferParagraph3 }}</p>

        <div class="voz-striking-icon-paragraph-title" style="margin-top: 5rem;">
          <IconCancel />
          <h1 class="voz-guideline-striking-prefer-paragraph-title">
            {{ vozGuidelineStrinkingParagraphEvit }}
          </h1>
        </div>
        <p class="voz-guideline-striking-prefer-paragraph">{{ vozGuidelineEvitParagraph4 }}</p>
        <p class="voz-guideline-striking-prefer-paragraph">{{ vozGuidelineEvitParagraph5 }}</p>
        <p class="voz-guideline-striking-prefer-paragraph">{{ vozGuidelineEvitParagraph6 }}</p>
      </div>

      <div class="gap-col"></div>

      <div class="voz-guideline-striking-column">
        <div class="voz-striking-icon-paragraph-title">
          <IconCheck />
          <h1 class="voz-guideline-striking-prefer-paragraph-title">
            {{ vozGuidelineStrikingParagraphExempl }}
          </h1>
        </div>
        <p class="voz-guideline-striking-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit1 }}</p>
        <p class="voz-guideline-striking-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit2 }}</p>
        <p class="voz-guideline-striking-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit3 }}</p>
        <p class="voz-guideline-striking-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit4 }}</p>

        <div class="voz-striking-icon-paragraph-title" style="margin-top: 3rem;">
          <IconCancel />
          <h1 class="voz-guideline-striking-prefer-paragraph-title">
            {{ vozGuidelineStrikingParagraphExempl2 }}
          </h1>
        </div>

        <p class="voz-guideline-striking-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit5 }}</p>
        <p class="voz-guideline-striking-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit6 }}</p>
        <p class="voz-guideline-striking-exempl-paragraph">{{ vozGuidelineExemplParagraphEvit7 }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VozPageMixin from '@/mixins/voz-page-mixin'
import { VozPageStore } from '@/store/verbal-identity-page/voz-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck, IconCancel } })
export default class VozGuidelineStrikingSection extends Mixins(VozPageMixin) {
  vozPageStore: PageStoreContract = getModule(VozPageStore, this.$store)

  get vozGuidelineStrikingTitle(): string {
    return this.getElementTitle(5, 0)
  }

  get vozGuidelineStrikingParagraph(): string {
    return this.getElementText(5, 1)
  }

  get vozGuidelineStrikingImageSrc(): string {
    return this.getElementMedia(5, 2)
  }

  get vozGuidelineStrikingCardTitle(): string {
    return this.getElementTitle(3, 7)
  }

  get vozGuidelineStrikingText(): string {
    return this.getElementText(3, 7)
  }

  //colum pref
  get vozGuidelinestrikingParagraphPref(): string {
    return this.getElementTitle(5, 3)
  }

  get vozGuidelinePreferParagraph1(): string {
    return this.getElementText(5, 3)
  }

  get vozGuidelinePreferParagraph2(): string {
    return this.getElementText(5, 4)
  }

  get vozGuidelinePreferParagraph3(): string {
    return this.getElementText(5, 5)
  }

  //colum evit
  get vozGuidelineStrinkingParagraphEvit(): string {
    return this.getElementTitle(5, 6)
  }

  get vozGuidelineEvitParagraph4(): string {
    return this.getElementText(5, 6)
  }

  get vozGuidelineEvitParagraph5(): string {
    return this.getElementText(5, 7)
  }

  get vozGuidelineEvitParagraph6(): string {
    return this.getElementText(5, 8)
  }


  //colum exempl
  get vozGuidelineStrikingParagraphExempl(): string {
    return this.getElementTitle(5, 9)
  }

  get vozGuidelineExemplParagraphEvit1(): string {
    return this.getElementText(5, 9)
  }

  get vozGuidelineExemplParagraphEvit2(): string {
    return this.getElementText(5, 10)
  }

  get vozGuidelineExemplParagraphEvit3(): string {
    return this.getElementText(5, 11)
  }

  get vozGuidelineExemplParagraphEvit4(): string {
    return this.getElementText(5, 12)
  }

  //colum exempl2
  get vozGuidelineStrikingParagraphExempl2(): string {
    return this.getElementTitle(5, 13)
  }

  get vozGuidelineExemplParagraphEvit5(): string {
    return this.getElementText(5, 13)
  }

  get vozGuidelineExemplParagraphEvit6(): string {
    return this.getElementText(5, 14)
  }

  get vozGuidelineExemplParagraphEvit7(): string {
    return this.getElementText(5, 15)
  }

  async getVozPage(): Promise<void> {
    await this.vozPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vozPageStore.isLoading) {
      await this.getVozPage()
    }
  }
}
</script>

<style lang="scss">
.voz-guideline-striking-content {
  display: grid;
  justify-content: center;
  margin-top: 150px;
  max-width: 1032px;
}

.voz-guideline-striking-title {
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: center;
  width: 1014px;
  margin: 0 auto;
}

.voz-guideline-striking-paragraph {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  width: 503px;
  margin: 0 auto;
  margin-top: 49px;
}

.voz-guideline-striking-wrapper {
  display: grid;
  grid-template-columns: 369px 307px 50px 307px;
  width: 1032px;
  margin: 0 auto;
  margin-top: 148px;
}

.voz-guideline-striking-card {
  width: 341px;
  height: 681px;
  border-radius: 16px;
  overflow: hidden;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  position: relative;
}

.voz-guideline-striking-overlay {
  position: absolute;
  inset: 0;

  padding: 24px;

  display: flex;
  flex-direction: column;
  color: #fff;
}

.voz-guideline-striking-number {
  font-size: 267px;
  font-weight: 600;
  margin: 0;
}

.voz-guideline-striking-content-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.voz-guideline-striking-card-title {
  font-family: GlobotipoCorporativaRegular;
  font-size: 28px;
  font-weight: 400;
  width: 140px;
  margin: 0;
}

.voz-guideline-striking-text {
  font-family: GlobotipoCorporativaTextosRegular;
  font-size: 18px;
  width: 200px;
  margin: 0;
}

.voz-guideline-striking-column {
  display: flex;
  flex-direction: column;
}

.voz-striking-icon-paragraph-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.voz-guideline-striking-prefer-paragraph-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 36px;
}

.voz-guideline-striking-prefer-paragraph,
.voz-guideline-striking-exempl-paragraph {
  margin-top: 0;
}

.voz-guideline-striking-prefer-paragraph,
.voz-guideline-striking-exempl-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
</style>
